var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloud28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.855 41.428c0 11.046 8.955 20 20 20h40c7.89 0 14.286-6.395 14.286-14.285 0-5.882-3.555-10.934-8.633-13.124-.868-11.832-10.742-21.162-22.795-21.162-7.46 0-14.086 3.574-18.258 9.103a20.052 20.052 0 0 0-4.6-.532c-11.045 0-20 8.955-20 20Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud28);
export default __webpack_public_path__ + "static/media/cloud_28.ed19a69e.svg";
export { ForwardRef as ReactComponent };